import React from "react";
import {
  Page,
  Text,
  Image,
  View,
  Document,
  StyleSheet,
} from "@react-pdf/renderer";
import bg from "../../../assets/images/bg/ticketbg.png";

import shield from "../../../assets/images/bg/shield.png";
import {
  getHotelPrice,
  getHotelTicketCommissionDiscount,
  getHotelTicketDisplayCommission,
  getHotelTicketDisplayTds,
  getHotelTicketDisplayTotal,
  getHotelAgentTicketFareDisplay,
  isHotelAgentB2BTicket,
  getHotelTicketPayableBase,
  getHotelPaymentStatusText,
  shouldShowHotelPaymentStatus,
  hasHotelConfirmationNumber,
  getHotelConfirmationNumberForDisplay,
  isHotelAdultGuest,
  shouldShowHotelLastCancellationDate,
  shouldShowHotelLastVoucherDate,
  formatHotelLastCancellationDateForDisplay,
  formatHotelLastVoucherDateForDisplay,
  formatHotelTicketCancellationDateForDisplay,
  shouldShowPanOnHotelTicket,
  shouldShowPassportOnHotelTicket,
  guestHasPan,
  guestHasPassport,
  formatHotelGuestDisplayName,
  groupHotelTicketGuestsByRoom,
  getHotelTicketGuestCount,
  getHotelTicketRoomCount,
  getEffectiveHotelBookingStatus,
  getHotelCancellationReasonLines,
  getHotelSpecialRequestFromTicket,
  formatRoomComboTitle,
} from "../../AllTickets/Hotel/hotelhelper";
import LogoImg from "../../../assets/images/logos/trip-logo.png";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { formatDate, DISPLAY_FORMAT } from "../../../helpers/dateHelper";
import Html from "react-pdf-html";
import { getRoomMealCategoryLabel } from "../../../pages/Hotels/hotelMealTypes";
import { HOTEL_PDF_FONT_FAMILY } from "./hotelPdfFont";

dayjs.extend(customParseFormat);

let dateFormat = "MMM, DD-YYYY";

const csssheet = {
  p: {
    margin: 0,
    fontSize: 12,
  },
};

const styles = StyleSheet.create({
  textDanger: {
    color: "#dc3545",
  },

  mb: {
    marginBottom: 8,
  },

  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    flexWrap: "wrap",
    flexGrow: 1,
  },

  wHalf: {
    flex: 0.5,
    marginBottom: 8,
  },
  tw: {
    flex: 0.2,
  },
  fourthHalf: {
    flex: 0.25,
    paddingRight: 5,
  },

  width32: {
    flex: 0.32,
  },
  trw: {
    flex: 0.3,
  },
  fw: {
    flex: 0.4,
  },
  headerHotelCol: {
    flex: 0.38,
    paddingRight: 6,
  },
  headerConfirmationCol: {
    flex: 0.28,
    paddingLeft: 4,
    paddingRight: 4,
  },
  headerDatesCol: {
    flex: 0.34,
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-start",
    paddingLeft: 6,
  },
  headerDateLine: {
    fontSize: 9,
    marginBottom: 2,
    textAlign: "right",
    flexShrink: 0,
  },
  sw: {
    flex: 0.6,
  },
  sew: {
    flex: 0.7,
  },

  mb8: {
    marginBottom: 6,
  },
  roomTitle: {
    fontSize: 11,
    fontWeight: 700,
    color: "#1c2b39",
    marginBottom: 6,
    marginTop: 4,
  },
  roomBlock: {
    marginBottom: 10,
    paddingBottom: 6,
    borderBottom: "1px solid #eef0f4",
  },
  description: {
    paddingLeft: 5,
  },

  hr: {
    borderBottom: "1px solid #e2e2e2",
    flex: 1,
    margin: "8px 0",
  },

  page: {
    padding: "12px 10px",
    fontFamily: HOTEL_PDF_FONT_FAMILY,
  },
  section: {},
  innerSection: {
    position: "relative",
  },
  headerBanner: {
    position: "relative",
    height: 46,
    marginBottom: 0,
  },
  pageBg: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: 46,
  },
  busWrapper: {
    padding: "8px 10px",
  },

  whiteText: {
    color: "#fff",
    fontSize: 12,
    marginBottom: 0,
    fontWeight: "bold",
  },
  title: { fontSize: 12, fontWeight: "bold", wordBreak: "break-all" },
  fadetitle: { color: "#a8a8a8", fontSize: 9, marginBottom: 1 },
  smallText: { fontSize: 10, marginBottom: 1 },
  xsmallText: {
    fontSize: 9,
    marginBottom: 3,
  },
  greytext: { color: "#666", fontSize: 9 },
  card: {
    padding: "8px 5px",
    marginBottom: 8,
    border: "1px solid #e2e2e2",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
  },

  insuranceCard: {
    border: "1px solid #02cb66",
    borderRadius: 6,
    textAlign: "center",
    padding: "10px 5px",
  },

  insurancetitle: {
    color: "#18a160",
    fontSize: 10,
  },

  dottedBorder: {
    borderTop: "1px dotted #a8a8a8",
    width: "100%",
    textAlign: "center",
  },

  coverage: {
    color: "#294782",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    margin: "8px 0",
  },

  coveragetitle: {
    color: "#294782",
    fontSize: 9,
  },
  addressDetails: {
    textAlign: "right",
    fontSize: 10,
    paddingBottom: 3,
  },
  flex5: {
    flex: 0.49,
  },
  logoSection: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    flexWrap: "wrap",
  },
});

export const getStatus = (status) => {
  switch (status) {
    case 1:
      return <Text style={{ color: "#f9e218" }}>CREATED</Text>;

    case 2:
      return <Text style={{ color: "#FFA500" }}>BLOCKED</Text>;

    case 3:
    case 10:
      return <Text style={{ color: "#008000" }}>CONFIRMED</Text>;

    case 4:
      return <Text style={{ color: "#FF0000" }}>FAILED</Text>;

    case 5:
      return <Text style={{ color: "#008000" }}>REJECTED</Text>;

    case 6:
      return <Text style={{ color: "#FF0000" }}>CANCELED</Text>;
      
    case 7:
      return <Text style={{ color: "#FF0000" }}>PENDING</Text>;
      
    case 8:
      return <Text style={{ color: "#FF0000" }}>CANCELLATIONREQUEST</Text>;
      
    case 9:
      return <Text style={{ color: "#FF0000" }}>CANCELLATIONPENDING</Text>;
    
    // case 10:
    //   return <Text style={{ color: "#FF0000" }}>CONFIRMED</Text>;

    case 11:
      return <Text style={{ color: "#FF0000" }}>VOUCHERED</Text>;

    default:
      return "";
  }
};

const parser = (str) => {
  if (str) {
    let doc = new DOMParser().parseFromString(str, "text/html");

    return doc.firstChild.innerHTML;
  }
};

const HotelDoc = ({ ticketData, cmsFareRules, withFare, Logo, withoutCancelDate = false }) => {
  let {
    baseAmount,
    taxAmount,
    convienenceFee,
    discount,
    grandTotal,
    insuranceTotal,
    noOfNights,
    otherCharges,
  } = getHotelPrice(ticketData);
  const commissionDiscount = getHotelTicketDisplayCommission(ticketData);
  const isAgentB2B = isHotelAgentB2BTicket(ticketData);
  const agentFareDisplay = isAgentB2B
    ? getHotelAgentTicketFareDisplay(ticketData)
    : null;
  const displayTds = isAgentB2B
    ? Number(agentFareDisplay?.tds ?? 0)
    : getHotelTicketDisplayTds(ticketData);
  const promoDiscount = Number(discount ?? 0);
  const ticketPayableTotal = getHotelTicketDisplayTotal(ticketData, {
    baseAmount,
    taxAmount,
    otherCharges,
    convienenceFee,
    insuranceTotal,
    discount,
    grandTotal,
  });
  const showPanColumn = shouldShowPanOnHotelTicket(ticketData);
  const showPassportColumn = shouldShowPassportOnHotelTicket(ticketData);
  const specialRequestText = getHotelSpecialRequestFromTicket(ticketData);
  const passengersByRoom = groupHotelTicketGuestsByRoom(ticketData).filter(
    (room) => (room?.paxInfoList ?? []).length > 0,
  );
  const showFare = withFare && !withoutCancelDate;
  const showLastCancellationDate =
    !withoutCancelDate && shouldShowHotelLastCancellationDate(ticketData);
  const showLastVoucherDate =
    !withoutCancelDate && shouldShowHotelLastVoucherDate(ticketData);
  const isCancelledTicket = getEffectiveHotelBookingStatus(ticketData) === 6;
  const cancellationReasonLines = isCancelledTicket
    ? getHotelCancellationReasonLines(ticketData)
    : [];
  const BASE = process.env.REACT_APP_BASE_URL;
  // function addStr(str, index) {
  //   return str;
  //   console.log(str);
  //   let stringArr = [];
  //   if (str.length > index) {
  //     stringArr.push(str.substring(0, index));
  //     let secText = str.substring(index, str.length);
  //     while (secText.length > index) {
  //       let temp = secText;
  //       stringArr.push(temp.substring(0, index));
  //       secText = temp.substring(index, secText.length);
  //     }
  //     stringArr.push(secText);
  //   }

  //   return stringArr.join(" ");
  //   // return str.substring(0, index) + " " + str.substring(index, str.length);
  // }

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {ticketData?.BookingStatus ? (
          <View style={styles.section}>
            <View style={styles.logoSection}>
              <View style={{ ...styles.flex5 }}>
                {Logo ? (
                  <Image
                    src={BASE + Logo.substring(1)}
                    style={{ height: 48, width: 100, marginBottom: 6 }}
                  ></Image>
                ) : (
                  <Image style={{ width: 100, height: 50 }} src={LogoImg} />
                )}
              </View>
              {ticketData?.agentDetails ? (
                <View style={{ ...styles.flex5, ...styles.addressDetails }}>
                  <Text>{ticketData?.agentDetails?.AgencyName} </Text>
                  <Text>
                    {ticketData?.agentDetails?.Address1}{" "}
                    {ticketData?.agentDetails?.Address2}
                  </Text>
                  {ticketData?.agentDetails?.City ||
                  ticketData?.agentDetails?.State ? (
                    <Text>
                      {ticketData?.agentDetails?.City}{" "}
                      {ticketData?.agentDetails?.State}
                    </Text>
                  ) : null}

                  <Text>Email: {ticketData?.agentDetails?.Email}</Text>
                  {ticketData?.agentDetails?.Phone ? (
                    <Text>Contact No.: {ticketData?.agentDetails?.Phone}</Text>
                  ) : null}
                </View>
              ) : ticketData?.adminDetails?.length > 0 ? (
                <View style={{ ...styles.flex5, ...styles.addressDetails }}>
                  <Text>{ticketData?.adminDetails[0]?.Address} </Text>
                  <Text>
                    {ticketData?.adminDetails[0]?.CityName}{" "}
                    {ticketData?.adminDetails[0]?.StateName}
                  </Text>
                  <Text>
                    {ticketData?.adminDetails[0]?.CountryName}{" "}
                    {ticketData?.adminDetails[0]?.PostalCode}
                  </Text>
                </View>
              ) : null}
            </View>

            <View style={styles.innerSection}>
              <View style={styles.headerBanner}>
                <Image src={bg} style={styles.pageBg} />
                <View style={{ padding: "12px 10px 6px 10px" }}>
                  <Text style={styles.whiteText}>{ticketData.HotelName}</Text>
                </View>
              </View>
              <View style={styles.busWrapper}>
                <View style={styles.card} wrap={false}>
                  <View style={styles.row}>
                    <View style={styles.headerHotelCol}>
                      <Text style={styles.title}>{ticketData.HotelName}</Text>
                      <Text style={styles.fadetitle}>
                        {ticketData.CityName}
                      </Text>
                    </View>

                    {hasHotelConfirmationNumber(ticketData) ? (
                      <View style={styles.headerConfirmationCol}>
                        <Text style={styles.title}>
                          {getHotelConfirmationNumberForDisplay(ticketData)}
                        </Text>
                        <Text style={styles.fadetitle}>
                          Hotel Confirmation No
                        </Text>
                      </View>
                    ) : null}

                    {(showLastCancellationDate || showLastVoucherDate) && (
                      <View style={styles.headerDatesCol}>
                        {showLastCancellationDate && (
                          <Text style={styles.headerDateLine} wrap={false}>
                            Last Cancellation Date :-{" "}
                            <Text style={styles.textDanger}>
                              {formatHotelTicketCancellationDateForDisplay(
                                ticketData,
                                "DD-MM-YYYY",
                              )}
                            </Text>
                          </Text>
                        )}
                        {showLastVoucherDate && (
                          <Text style={styles.headerDateLine} wrap={false}>
                            Last Voucher Date :-{" "}
                            <Text style={styles.textDanger}>
                              {formatHotelTicketCancellationDateForDisplay(
                                ticketData,
                                "DD-MM-YYYY",
                              )}
                            </Text>
                          </Text>
                        )}
                      </View>
                    )}
                  </View>

                  <View style={styles.hr}></View>

                  <View style={styles.row}>
                    <View style={styles.fourthHalf}>
                      <Text style={styles.title}>{ticketData.RefNumber}</Text>
                      <Text style={styles.fadetitle}>Ticket Ref Number</Text>
                    </View>
                    <View style={styles.fourthHalf}>
                      <Text style={styles.title}>
                        {getStatus(ticketData.BookingStatus)}
                      </Text>
                      <Text style={styles.fadetitle}>Status</Text>
                    </View>
                    <View style={styles.fourthHalf}>
                      <Text style={styles.title}>{ticketData.NoOfRooms}</Text>
                      <Text style={styles.fadetitle}>Room(s)</Text>
                    </View>
                    {shouldShowHotelPaymentStatus(ticketData) ? (
                    <View style={styles.fourthHalf}>
                      <Text style={styles.title}>
                        {getHotelPaymentStatusText(ticketData)}
                      </Text>
                      <Text style={styles.fadetitle}>Payment Status</Text>
                    </View>
                    ) : null}
                  </View>
                </View>

                {/* Hotel info */}

                <View style={styles.card}>
                  <View style={styles.mb}>
                    <Text style={styles.title}>Hotel Details</Text>
                    <Text style={styles.fadetitle}>
                      Here are the details of your Hotel booked from{" "}
                      {formatDate(ticketData.CheckInDate, dateFormat)} to{" "}
                      {formatDate(ticketData.CheckOutDate, dateFormat)}
                    </Text>
                  </View>

                  <View style={{ ...styles.row, ...styles.mb }}>
                    <View style={styles.fw}>
                      <Text style={styles.smallText}>
                        {ticketData.HotelName}
                      </Text>
                      <Text style={{ ...styles.fadetitle, color: "#000" }}>
                        {ticketData.CityName}
                      </Text>
                    </View>

                    <View style={styles.sw}>
                      <View style={{ ...styles.row, alignItems: "flex-start" }}>
                        <View
                          style={{
                            ...styles.width32,
                            textAlign: "center",
                          }}
                        >
                          <Text style={styles.title}>
                            {formatDate(ticketData.CheckInDate, dateFormat)}
                          </Text>
                          <Text style={styles.fadetitle}>Check In</Text>
                        </View>
                        <View
                          style={{
                            ...styles.width32,
                            margin: "5px 2px 0 0",
                            paddingRight: 5,
                          }}
                        >
                          <View style={styles.dottedBorder}>
                            <Text
                              style={{
                                ...styles.fadetitle,
                                display: "inline",
                                paddingTop: 3,
                                textAlign: "center",
                              }}
                            >
                              {ticketData.CityName}
                            </Text>
                          </View>
                        </View>

                        <View
                          style={{
                            ...styles.width32,
                            textAlign: "center",
                          }}
                        >
                          <Text style={styles.title}>
                            {formatDate(ticketData.CheckOutDate, dateFormat)}
                          </Text>
                          <Text style={styles.fadetitle}>Check Out</Text>
                        </View>
                      </View>
                    </View>
                  </View>

                  <View style={styles.row}>
                    <View style={styles.width32}>
                      <Text style={styles.fadetitle}>Hotel Address</Text>
                      <Text style={styles.smallText}>
                        {ticketData.HotelAddress.address}
                      </Text>
                    </View>
                    <View style={styles.width32}>
                      <Text style={styles.fadetitle}>Star Rating</Text>
                      <Text style={styles.smallText}>
                        {ticketData.StarRating}
                      </Text>
                    </View>
                    <View style={styles.width32}>
                      <Text style={styles.fadetitle}>No. of Nights</Text>
                      <Text style={styles.smallText}>{noOfNights}</Text>
                    </View>
                  </View>

                  <View style={styles.row}>
                    <View style={styles.width32} />
                    <View style={styles.width32}>
                      <Text style={styles.fadetitle}>No. of Guest</Text>
                      <Text style={styles.smallText}>
                        {getHotelTicketGuestCount(ticketData)}
                      </Text>
                    </View>
                    <View style={styles.width32}>
                      <Text style={styles.fadetitle}>No. of Rooms</Text>
                      <Text style={styles.smallText}>
                        {getHotelTicketRoomCount(ticketData)}
                      </Text>
                    </View>
                  </View>

                  <View style={styles.row}>
                    {ticketData.Rooms.map((item, i) => {
                      const mealCategory = getRoomMealCategoryLabel(item);
                      return (
                      <View key={i + "roomid"} style={styles.wHalf}>
                        <Text style={styles.fadetitle}>Room Name</Text>
                        <Text style={styles.smallText}>{formatRoomComboTitle(item.roomName)}</Text>
                        {mealCategory ? (
                          <Text style={{ fontSize: 10, color: "#5c6b8a", marginTop: 2 }}>
                            {mealCategory}
                          </Text>
                        ) : null}
                      </View>
                    );
                    })}
                  </View>
                </View>

                {/* Contact Details */}

                <View style={styles.card} wrap={false}>
                  <View style={styles.mb}>
                    <Text style={styles.title}>Contact Details</Text>
                  </View>

                  <View style={styles.row}>
                    <View style={styles.width32}>
                      <Text style={styles.fadetitle}>Name</Text>
                      <Text style={styles.smallText}>
                        {ticketData.guests.length > 0
                          ? formatHotelGuestDisplayName(ticketData.guests[0])
                          : null}
                      </Text>
                    </View>

                    <View style={styles.width32}>
                      <Text style={styles.fadetitle}>Mobile Number</Text>
                      <Text style={styles.smallText}>{ticketData.phoneNo}</Text>
                    </View>
                    <View style={styles.width32}>
                      <Text style={styles.fadetitle}>Email</Text>
                      <Text style={styles.smallText}>{ticketData.email}</Text>
                    </View>
                  </View>
                </View>

                {specialRequestText ? (
                  <View style={styles.card} wrap={false}>
                    <View style={styles.mb}>
                      <Text style={styles.title}>Special Request</Text>
                    </View>
                    <Text style={styles.smallText}>{specialRequestText}</Text>
                  </View>
                ) : null}

                {/* pax details */}

                <View style={styles.card}>
                  <View style={styles.mb}>
                    <Text style={styles.title}>Passengers Details</Text>
                  </View>
                  {passengersByRoom.length > 0
                    ? passengersByRoom.map((room, roomIndex) => (
                        <View
                          style={styles.roomBlock}
                          key={`pdf-pax-room-${roomIndex}`}
                        >
                          <Text style={styles.roomTitle}>
                            Room {roomIndex + 1}
                          </Text>
                          {(room?.paxInfoList ?? []).map((item, guestIndex) => (
                            <View style={styles.row} key={`pdf-pax-${roomIndex}-${guestIndex}`}>
                              <View style={styles.tw}>
                                <Text style={styles.fadetitle}>Name</Text>
                                <Text style={styles.smallText}>
                                  {formatHotelGuestDisplayName(item)}
                                </Text>
                              </View>
                              {item.Age !== undefined && item.Age !== null && (
                                <View style={styles.tw}>
                                  <Text style={styles.fadetitle}>Age</Text>
                                  <Text style={styles.smallText}>{item.Age}</Text>
                                </View>
                              )}
                              {showPassportColumn && isHotelAdultGuest(item) && (
                                <View style={styles.tw}>
                                  <Text style={styles.fadetitle}>
                                    Passport Number
                                  </Text>
                                  <Text style={styles.smallText}>
                                    {item.PassportNo ||
                                      item.passportNo ||
                                      "—"}
                                  </Text>
                                </View>
                              )}
                              {showPanColumn && isHotelAdultGuest(item) && (
                                <View style={styles.tw}>
                                  <Text style={styles.fadetitle}>Pan No.</Text>
                                  <Text style={styles.smallText}>
                                    {item.Pan || item.pan || "—"}
                                  </Text>
                                </View>
                              )}
                              <View style={styles.tw}>
                                <Text style={styles.fadetitle}>Guest Type</Text>
                                <Text style={styles.smallText}>
                                  {item.GuestType ?? item.guestType ?? "Adult"}
                                </Text>
                              </View>
                            </View>
                          ))}
                        </View>
                      ))
                    : null}
                </View>

                {/* insurance  */}

                {ticketData?.insuranceRequired === 1 &&
                ticketData.insuranceData &&
                ticketData?.insuranceData?.serviceType === 2 ? (
                  <View style={styles.card} wrap={false}>
                    <View style={styles.mb}>
                      <Text style={styles.title}>
                        THE SMART INSURANCE COVER
                      </Text>
                      <Text style={styles.greytext}>
                        EASY CLAIM PROCESS | NO QUESTIONS ASKED
                      </Text>
                    </View>

                    <View style={styles.row}>
                      <View style={styles.width32}>
                        <View style={styles.insuranceCard}>
                          <Text style={styles.insurancetitle}>
                            {ticketData?.insuranceData.description_box_1}
                          </Text>
                        </View>
                      </View>

                      <View style={styles.width32}>
                        <View style={styles.insuranceCard}>
                          <Text style={styles.insurancetitle}>
                            {ticketData?.insuranceData.description_box_2}
                          </Text>
                        </View>
                      </View>
                      <View style={styles.width32}>
                        <View style={styles.insuranceCard}>
                          <Text style={styles.insurancetitle}>
                            {ticketData?.insuranceData.description_box_3}
                          </Text>
                        </View>
                      </View>
                    </View>

                    <View style={styles.coverage}>
                      <Image
                        style={{ width: 10, height: 10, marginRight: 5 }}
                        src={shield}
                      />
                      <Text style={styles.coveragetitle}>
                        Insurance Coverage Amount :{" "}
                        {ticketData?.insuranceData.insuranceCoverage}
                      </Text>
                    </View>
                  </View>
                ) : null}

                {/* fare */}
                {showFare ? (
                  <View>
                    <View style={styles.card} wrap={false}>
                      <View style={styles.mb}>
                        <Text style={styles.title}>Fare Details</Text>
                      </View>

                      <View style={{ ...styles.row, ...styles.mb8 }}>
                        <View style={styles.sw}>
                          <Text style={styles.smallText}>
                            {isAgentB2B ? "Room Price" : "Base Fare"}
                          </Text>
                        </View>

                        <View style={styles.fourthHalf}>
                          <Text style={styles.smallText}>
                            ₹{" "}
                            {isAgentB2B
                              ? agentFareDisplay?.roomPrice
                              : baseAmount}
                          </Text>
                        </View>
                      </View>

                      <View style={{ ...styles.row, ...styles.mb8 }}>
                        <View style={styles.sw}>
                          <Text style={styles.smallText}>
                            {isAgentB2B ? "Taxes and Fees" : "Taxes"}
                          </Text>
                        </View>

                        <View style={styles.fourthHalf}>
                          <Text style={styles.smallText}>
                            ₹{" "}
                            {isAgentB2B ? agentFareDisplay?.taxes : taxAmount}
                          </Text>
                        </View>
                      </View>
                      {!isAgentB2B ? (
                        <View style={{ ...styles.row, ...styles.mb8 }}>
                          <View style={styles.sw}>
                            <Text style={styles.smallText}>Other Charges</Text>
                          </View>

                          <View style={styles.fourthHalf}>
                            <Text style={styles.smallText}>
                              ₹ {otherCharges}
                            </Text>
                          </View>
                        </View>
                      ) : null}

                      {Math.ceil(Math.abs(Number(convienenceFee) || 0)) >= 1 ? (
                      <View style={{ ...styles.row, ...styles.mb8 }}>
                        <View style={styles.sw}>
                          <Text style={styles.smallText}>Convenience Fee</Text>
                        </View>

                        <View style={styles.fourthHalf}>
                          <Text style={styles.smallText}>
                            ₹ {convienenceFee}
                          </Text>
                        </View>
                      </View>
                      ) : null}
                      {ticketData?.insuranceRequired === 1 &&
                      ticketData.insuranceData ? (
                        <View style={{ ...styles.row, ...styles.mb8 }}>
                          <View style={styles.sw}>
                            <Text style={styles.smallText}>
                              Insurance Amount
                            </Text>
                          </View>

                          <View style={styles.fourthHalf}>
                            <Text style={styles.smallText}>
                              ₹ {insuranceTotal}
                            </Text>
                          </View>
                        </View>
                      ) : null}

                      {isAgentB2B && commissionDiscount > 0 ? (
                        <View style={{ ...styles.row, ...styles.mb8 }}>
                          <View style={styles.sw}>
                            <Text style={styles.smallText}>
                              - Commission Earned
                            </Text>
                          </View>

                          <View style={styles.fourthHalf}>
                            <Text style={styles.smallText}>
                              ₹ {commissionDiscount}
                            </Text>
                          </View>
                        </View>
                      ) : null}
                      {isAgentB2B && displayTds > 0 ? (
                        <View style={{ ...styles.row, ...styles.mb8 }}>
                          <View style={styles.sw}>
                            <Text style={styles.smallText}>+ TDS</Text>
                          </View>

                          <View style={styles.fourthHalf}>
                            <Text style={styles.smallText}>₹ {displayTds}</Text>
                          </View>
                        </View>
                      ) : null}
                      {!isAgentB2B || promoDiscount > 0 ? (
                        <View style={{ ...styles.row, ...styles.mb8 }}>
                          <View style={styles.sw}>
                            <Text style={styles.smallText}>Discount</Text>
                          </View>

                          <View style={styles.fourthHalf}>
                            <Text style={styles.smallText}>
                              ₹ {promoDiscount}
                            </Text>
                          </View>
                        </View>
                      ) : null}

                      <View style={{ ...styles.row, ...styles.mb8 }}>
                        <View style={styles.sw}>
                          <Text style={styles.smallText}>
                            {isAgentB2B ? "Final Payment" : "Total"}
                          </Text>
                        </View>

                        <View style={styles.fourthHalf}>
                          <Text style={styles.smallText}>
                            ₹ {ticketPayableTotal}
                          </Text>
                        </View>
                      </View>
                    </View>
                    {isCancelledTicket && cancellationReasonLines.length > 0 ? (
                      <View style={styles.card}>
                        <View style={styles.mb}>
                          <Text style={styles.title}>Cancellation Reason:</Text>
                        </View>
                        <View style={styles.termCon}>
                          {cancellationReasonLines.map((line, index) => (
                            <Text
                              key={`pdf-hotel-cancel-reason-${index}`}
                              style={styles.smallText}
                            >
                              {line}
                            </Text>
                          ))}
                        </View>
                      </View>
                    ) : null}
                    {/* terms */}
                    <View style={styles.card}>
                      <View style={styles.mb}>
                        <Text style={styles.title}>Note</Text>
                      </View>

                      {cmsFareRules?.cancelPolicyDescription ? (
                        <View style={styles.termCon}>
                          <View style={styles.description}>
                            <Text
                              style={{ ...styles.smallText, marginBottom: 2 }}
                            >
                              Cancel Policy
                            </Text>

                            <Html stylesheet={csssheet}>
                              {parser(cmsFareRules?.cancelPolicyDescription)}
                            </Html>
                          </View>

                          {cmsFareRules?.covidRulesDescription ? (
                            <View style={styles.description}>
                              <Text
                                style={{ ...styles.smallText, marginBottom: 2 }}
                              >
                                Covid Policy
                              </Text>

                              <Html stylesheet={csssheet}>
                                {parser(cmsFareRules?.covidRulesDescription)}
                              </Html>
                            </View>
                          ) : null}

                          {cmsFareRules?.otherRulesDescription ? (
                            <View style={styles.description}>
                              <Text
                                style={{ ...styles.smallText, marginBottom: 2 }}
                              >
                                Other Policy
                              </Text>

                              <Html stylesheet={csssheet}>
                                {parser(cmsFareRules?.otherRulesDescription)}
                              </Html>
                            </View>
                          ) : null}
                        </View>
                      ) : (
                        <View style={styles.termCon}>
                          <View style={styles.description}>
                            <Text
                              style={{ ...styles.smallText, marginBottom: 2 }}
                            >
                              * Early check in and late check out is subject to
                              availability.
                            </Text>

                            <Text
                              style={{ ...styles.smallText, marginBottom: 2 }}
                            >
                              * The passenger has to furnish a photo identity
                              and address proof at the time of verification
                              failing to which all passenger on that voucher
                              shall not be entertained with any refunds or
                              restitution.
                            </Text>

                            <Text
                              style={{ ...styles.smallText, marginBottom: 2 }}
                            >
                              * Standard Check in time is 1400 hrs / check out
                              time 1200 hrs unless specified.
                            </Text>

                            <Text
                              style={{ ...styles.smallText, marginBottom: 2 }}
                            >
                              * The refund for early check out or unutilized
                              night or service is subject to discretion of the
                              hotel & the supplier, we strongly recommend to get
                              a letter from the hotel favoring no charges for
                              early check out.
                            </Text>

                            <Text
                              style={{ ...styles.smallText, marginBottom: 2 }}
                            >
                              * All additional charges other than the room
                              charges and inclusions as mentioned in the booking
                              voucher are to be borne and paid separately during
                              check-out. Please make sure that you are aware of
                              all such charges that may comes as extras. Some of
                              them can be WiFi costs, Mini Bar, Laundry
                              Expenses, Telephone calls, Room Service, Snacks
                              etc.
                            </Text>

                            <Text
                              style={{ ...styles.smallText, marginBottom: 2 }}
                            >
                              * Voucher covers only those taxes which are
                              included in the booking price (if included), all
                              various other applicable taxes needs to be settled
                              directly by guest .
                            </Text>

                            <Text
                              style={{ ...styles.smallText, marginBottom: 2 }}
                            >
                              * We are not liable for any loss or damage caused
                              during your stay in the hotel or while availing
                              any service.
                            </Text>

                            <Text
                              style={{ ...styles.smallText, marginBottom: 2 }}
                            >
                              * We have no relevance with the room service or
                              food menu or any other service as these are all as
                              per the hotel standards.
                            </Text>

                            <Text
                              style={{ ...styles.smallText, marginBottom: 2 }}
                            >
                              * The hotel reserves the right of admission.
                              Accommodation can be denied to guests posing as a
                              'couple' if suitable proof of identification is
                              not presented at the time of check in. we will not
                              be responsible for any check in denied by the
                              hotel due to aforesaid reason.
                            </Text>
                          </View>
                        </View>
                      )}
                    </View>
                  </View>
                ) : null}

                {!showFare ? (
                  <View style={styles.card}>
                    <View style={styles.mb}>
                      <Text style={styles.title}>Note</Text>
                    </View>

                    {cmsFareRules?.cancelPolicyDescription ? (
                      <View style={styles.termCon}>
                        <View style={styles.description}>
                          <Text
                            style={{ ...styles.smallText, marginBottom: 2 }}
                          >
                            Cancel Policy
                          </Text>

                          <Html stylesheet={csssheet}>
                            {parser(cmsFareRules?.cancelPolicyDescription)}
                          </Html>
                        </View>

                        {cmsFareRules?.covidRulesDescription ? (
                          <View style={styles.description}>
                            <Text
                              style={{ ...styles.smallText, marginBottom: 2 }}
                            >
                              Covid Policy
                            </Text>

                            <Html stylesheet={csssheet}>
                              {parser(cmsFareRules?.covidRulesDescription)}
                            </Html>
                          </View>
                        ) : null}

                        {cmsFareRules?.otherRulesDescription ? (
                          <View style={styles.description}>
                            <Text
                              style={{ ...styles.smallText, marginBottom: 2 }}
                            >
                              Other Policy
                            </Text>

                            <Html stylesheet={csssheet}>
                              {parser(cmsFareRules?.otherRulesDescription)}
                            </Html>
                          </View>
                        ) : null}
                      </View>
                    ) : (
                      <View style={styles.termCon}>
                        <View style={styles.description}>
                          <Text
                            style={{ ...styles.smallText, marginBottom: 2 }}
                          >
                            * Early check in and late check out is subject to
                            availability.
                          </Text>

                          <Text
                            style={{ ...styles.smallText, marginBottom: 2 }}
                          >
                            * The passenger has to furnish a photo identity and
                            address proof at the time of verification failing to
                            which all passenger on that voucher shall not be
                            entertained with any refunds or restitution.
                          </Text>

                          <Text
                            style={{ ...styles.smallText, marginBottom: 2 }}
                          >
                            * Standard Check in time is 1400 hrs / check out
                            time 1200 hrs unless specified.
                          </Text>

                          <Text
                            style={{ ...styles.smallText, marginBottom: 2 }}
                          >
                            * The refund for early check out or unutilized night
                            or service is subject to discretion of the hotel &
                            the supplier, we strongly recommend to get a letter
                            from the hotel favoring no charges for early check
                            out.
                          </Text>

                          <Text
                            style={{ ...styles.smallText, marginBottom: 2 }}
                          >
                            * All additional charges other than the room charges
                            and inclusions as mentioned in the booking voucher
                            are to be borne and paid separately during
                            check-out. Please make sure that you are aware of
                            all such charges that may comes as extras. Some of
                            them can be WiFi costs, Mini Bar, Laundry Expenses,
                            Telephone calls, Room Service, Snacks etc.
                          </Text>

                          <Text
                            style={{ ...styles.smallText, marginBottom: 2 }}
                          >
                            * Voucher covers only those taxes which are included
                            in the booking price (if included), all various
                            other applicable taxes needs to be settled directly
                            by guest .
                          </Text>

                          <Text
                            style={{ ...styles.smallText, marginBottom: 2 }}
                          >
                            * We are not liable for any loss or damage caused
                            during your stay in the hotel or while availing any
                            service.
                          </Text>

                          <Text
                            style={{ ...styles.smallText, marginBottom: 2 }}
                          >
                            * We have no relevance with the room service or food
                            menu or any other service as these are all as per
                            the hotel standards.
                          </Text>

                          <Text
                            style={{ ...styles.smallText, marginBottom: 2 }}
                          >
                            * The hotel reserves the right of admission.
                            Accommodation can be denied to guests posing as a
                            'couple' if suitable proof of identification is not
                            presented at the time of check in. we will not be
                            responsible for any check in denied by the hotel due
                            to aforesaid reason.
                          </Text>
                        </View>
                      </View>
                    )}
                  </View>
                ) : null}

              </View>
            </View>
          </View>
        ) : null}
      </Page>
    </Document>
  );
};

export default HotelDoc;
